var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.9V6.60001L13.71 10.64L18.09 11.02L14.77 13.9L15.77 18.18L12 15.9ZM22 9.74001L14.81 9.12001L12 2.5L9.19 9.13L2 9.74001L7.46 14.47L5.82 21.5L12 17.77L18.18 21.5L16.55 14.47L22 9.74001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.9V6.60001L13.71 10.64L18.09 11.02L14.77 13.9L15.77 18.18L12 15.9ZM22 9.74001L14.81 9.12001L12 2.5L9.19 9.13L2 9.74001L7.46 14.47L5.82 21.5L12 17.77L18.18 21.5L16.55 14.47L22 9.74001Z",
    fill: "#8285F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentTask);
export default __webpack_public_path__ + "static/media/assessment-task.faad29ef16fb372abf8c00e6cdb44ed4.svg";
export { ForwardRef as ReactComponent };